module.exports = __webpack_public_path__ + "img/delivery_white.405d289c.svg";